import unescapedText from 'I18n/utils/unescapedText';
import { RequirablePropertyInputEnum } from '../../input/PropertyInputGetters';
import { usePropertyDefinition } from '../hooks/usePropertyDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
const BillingFrequencyPropertyInputEnumShim = props => {
  const propertyDefinition = usePropertyDefinition();
  const placeholder = unescapedText('customerDataProperties.PropertyInputEnumShim.billingFrequencyPlaceholder');
  const emptyOptionLabel = unescapedText('customerDataProperties.PropertyInputEnumShim.billingFrequencyPlaceholder');
  return /*#__PURE__*/_jsx(RequirablePropertyInputEnum, Object.assign({}, props, {
    placeholder: placeholder,
    property: propertyDefinition,
    emptyOptionLabel: emptyOptionLabel,
    clearable: false
  }));
};
export default BillingFrequencyPropertyInputEnumShim;